import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Location} from '@angular/common';
import { PopupService } from 'src/app/core/popupmessage/popupmessage.service';
// import { Observable } from 'rxjs/Rx'

// import {PopupMesseageService} from '../services/popupMessageService';

@Injectable()
export class NavGuardService implements CanActivate{
    private lastUrl:string | undefined;
    private dirtyPage:boolean = false;
    private memUid:string = "";
    private currentUrl:string = "";

    constructor(
        private router:Router,
        private popupSrv:PopupService,
        private location: Location
    ){}

    public canActivate(route: ActivatedRouteSnapshot, state:RouterStateSnapshot){
        console.log("NavGuardService:checking CanActivate");
        this.lastUrl = state.url;
        if(this.dirtyPage){
            this.discardChanges();
            setTimeout(()=>{
                if(this.currentUrl !== ""){
                    this.updateLocation(this.currentUrl);
                }
            },500)
            return false;
        }else{
            this.currentUrl = "";
            return true;
        }
    }
    public verifiyNavChange(){
        
        this.removeMemToken()
        this.currentUrl = ""
        this.dirtyPage = false;
        this.router.navigate([this.lastUrl]);
    };
    public setPageIsDirty(isDirty:boolean){
        this.dirtyPage = isDirty;
    }
    public getPageIsDirty():boolean{
        return this.dirtyPage;
    }

    public setMemToken(memUid:string){
        this.memUid = memUid;
    }
    public updateLocation(location:string){
        this.currentUrl = location;
        this.location.replaceState(location);
    }

    private removeMemToken(){
        // if(this.memUid.length > 0){
        //     this.checkoutSrv.memRemoveCheckoutObject(this.memUid);
        // }
        // this.memUid = "";
    }

    discardChanges(){
        this.popupSrv.confirm("Confirm Leaving Page","Make sure you save before leaving.","Continue with leaving the page?",1).subscribe((result)=>{
            if(result === true){
                this.verifiyNavChange()
            }
        });
        // this.popup.warningPopup(
        //     "Unsaved Data Detected",
        //         "Discard unsaved data?",
        //         "Click confirm to proceed or cancel to remain on current page.",
        //         ()=>{
        //             this.verifiyNavChange()
        //         },
        //         ()=>{}
        // );
    }

}